// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1445":"d78cee87","2918":"7f8429d9","3206":"49482cc9","6225":"d9dde868"}[chunkId] + ".chunk.css";
};